import { FontSource } from '@wix/ambassador-emails-email-marketing-v1-font/types';
import { getFontsFromMjml, getMjmlFonts } from '@wix/wix-emails-commons';
import { isSystemFont } from './utils/isSystemFont';
import { getUnformattedFontDisplayName } from './utils/getUnformattedFontDisplayName';
export function getMjHeadElementsForFonts(mjml, customFonts, customFontsEnabled) {
  if (customFontsEnabled) {
    const fonts = getFontsFromMjml({
      mjml,
      extendedList: [{
        name: 'Ubuntu',
        fontSource: FontSource.WEBFONTS_WEBFONT
      }],
      customFonts
    });
    const webFonts = fonts.filter(font => !isSystemFont(font.name) && font.fontSource !== FontSource.CUSTOM_FONT);
    const fontData = webFonts.map(font => {
      const unformattedDisplayName = getUnformattedFontDisplayName(font.name) || font.name;
      const nameForLink = unformattedDisplayName.replaceAll(' ', '+');
      return {
        ...font,
        unformattedDisplayName,
        nameForLink
      };
    });
    const mjFontElements = fontData.map(font => ({
      tag: 'mj-font',
      attrs: {
        name: font.name,
        href: `https://static.parastorage.com/tag-bundler/api/v1/fonts-cache/googleAPI/css?family=${font.nameForLink}:n,b,i,bi&display=swap`
      }
    }));
    const usedCustomFonts = customFonts != null && customFonts.length ? fonts.filter(font => font.fontSource === FontSource.CUSTOM_FONT) : [];
    const customFontRules = usedCustomFonts == null ? void 0 : usedCustomFonts.map(font => `
      @font-face {
          font-family: ${font.name};
          src: url('${font.downloadUrl}') format('truetype');
      }`).join('\n');
    return {
      mjFontElements,
      mjStyleElement: customFontRules ? `<mj-style>${customFontRules}</mj-style>` : undefined
    };
  }
  const fonts = getMjmlFonts(mjml, {
    Ubuntu: {
      displayName: 'Ubuntu',
      cssFontFamily: 'Ubuntu',
      supportedInHtmlEmails: true
    }
  });
  const webFonts = fonts.filter(font => !isSystemFont(font.displayName));
  const fontData = webFonts.map(font => {
    const unformattedDisplayName = getUnformattedFontDisplayName(font.displayName) || font.displayName;
    const nameForLink = unformattedDisplayName.replaceAll(' ', '+');
    return {
      ...font,
      unformattedDisplayName,
      nameForLink
    };
  });
  const mjFontElements = fontData.map(font => ({
    tag: 'mj-font',
    attrs: {
      name: font.displayName,
      href: `https://static.parastorage.com/tag-bundler/api/v1/fonts-cache/googleAPI/css?family=${font.nameForLink}:n,b,i,bi&display=swap`
    }
  }));
  return {
    mjFontElements
  };
}
//# sourceMappingURL=get-mj-elements-for-fonts.js.map